export enum LeaderBoardContests {
  "day" = "day",
  "month" = "month",
  "year" = "year"
}

export enum ContestSubType {
  "contest" = "contest",
  "winners" = "winners"
}